export class PopupsDataModel {

    popupModel = {
        accountId: null,
        employeeId: null,
        employeeName: null,
        message: null,
        expiryDate: null,
        expiringOnId: null,
        accountName: null,
        id: null
    };

    expiresOnList = [
        {label: 'When Viewed', id: 1},
        {label: 'Date', id: 2},
        {label: 'Never', id: 3},
    ];


}
